import { atom } from 'jotai';
import type { WorkMode } from '../../contracts/work-mode';

// AGENTS-OWNED, re-exported name-intact. The union now has one definition site,
// in `@heidi/agents/contracts`, because the composer chrome that renders the
// Auto/Evidence pill lives in that package and a package may not import `@/`.
// The atoms below stay here: they are jotai state, which the inert contracts
// zone cannot hold.
export type { WorkMode };

/**
 * One-shot request to enter the Work home in a specific mode (mirrors
 * ``pendingWorkHomeViewAtom``). ``'evidence'`` selects the composer pill
 * only — page chrome stays Work so the Auto | Evidence toggle stays mounted.
 * ``{ mode: 'work', persist: true }`` is Home and is saved. A plain ``'work'``
 * is New chat and skips that save, so the two do not depend on the view atom.
 * ``ProjectsPage`` consumes this before paint and clears it. An ``'evidence'``
 * request is held while a chat route is still open, then applied once Home
 * loads — after the chat-lifetime reset, which would otherwise force Work.
 */
type PendingWorkMode =
  | WorkMode
  | {
      mode: 'work';
      persist: true;
    };

/** Home writes this so the save does not depend on the view atom still being set. */
export const pendingWorkHomeMode = { mode: 'work', persist: true } as const;

export const pendingWorkModeAtom = atom<PendingWorkMode | null>(null);

/**
 * Effective composer mode on the Work home, published so the drawer Evidence
 * row can highlight. A routed chat publishes ``'work'``.
 */
export const currentWorkModeAtom = atom<WorkMode>('work');
